import { useState } from "react";

export const useTitleHeading = () => {
    const [isListing, setIsListing] = useState(false);
  return {
    isListing,
    setIsListing
  }
}
